import * as yup from "yup";
import { getStringRequiredFieldMessage } from "@shared/utils/yup-extensions";

export const newPresentationSchema = yup.object({
  title: yup.string(),
  clientName: yup.string(),
  propertyInfo: yup
    .string()
    .required(getStringRequiredFieldMessage({ label: "property info" }))
    .trim()
    .min(5, "Property info must be longer"),
});

export type NewPresentationFormSchema = yup.InferType<
  typeof newPresentationSchema
>;

export const buildCreatePresentationPrompt = (
  values: NewPresentationFormSchema,
): string => {
  const intro = values.title
    ? `Create a new CMA presentation titled "${values.title}"`
    : "Create a new CMA presentation";
  const client = values.clientName ? ` for client ${values.clientName}` : "";
  const property = `\n\nSubject property info:\n${values.propertyInfo}`;
  return `${intro}${client}.${property}`;
};
